import { CLIENT_BUILD } from './build-info.js';

const uuid = () => crypto.randomUUID();
export const pageSessionId = uuid();
function installation() {
  try {
    const key = 'haere:telemetry-installation';
    const saved = localStorage.getItem(key);
    if (saved && /^[a-f0-9-]{36}$/.test(saved)) return saved;
    const id = uuid(); localStorage.setItem(key, id); return id;
  } catch { return uuid(); }
}
export const browserInstallationId = installation();
export function observationHeaders(operationId?: string): Record<string, string> {
  return { 'x-haere-session-id': pageSessionId, 'x-haere-installation-id': browserInstallationId, 'x-haere-build-id': CLIENT_BUILD.buildId,
    ...(operationId ? { 'x-haere-operation-id': operationId } : {}) };
}
